export default "__VITE_ASSET__f0b02a85__"